













































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { MONTH_FORMAT_JA, MONTH_FORMAT, dayjs, DT_FORMAT_INPUT, D_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { PaymentTeacherService } from '../../biz/remote/PaymentTeacherService';
import { DataRecord } from '../../../src_server/entity/dto/DataRecord';

@Component({
  components: { CommonDialog },
  filters: {
    monthFormat: (dt: Date) => {
      return dayjs(dt).format(MONTH_FORMAT_JA);
    },
    dFormat: (dt: Date) => {
      return dayjs(dt).format(D_FORMAT_JA);
    },
    // amountFormat: (amount: number) => {
    //   return amount.toLocaleString();
    // },
    amountFormat: (num: number) => {
      return num.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
    },
  },
})
export default class TeacherPaymentDialog extends Vue {
  private target_month = '';
  private user_id = '';
  private building_id = '';
  private dto: DataRecord = new DataRecord();

  @Watch('target_month')
  async changeMonth() {
    await this.loadData(this.user_id, this.building_id, this.target_month);
  }

  async loadData(user_id: string, building_id: string, target_month: string) {
    const biz = new PaymentTeacherService();
    const result = await biz.getTeacherPaymentByUserID(target_month, building_id, dayjs().format(DT_FORMAT_INPUT), user_id);
    console.log(result.data);
    if (!result.data) {
      this.dto = new DataRecord();
    } else {
      this.dto = result.data;
    }
  }

  public async show(user_id: string, building_id: string) {
    this.user_id = user_id;
    this.target_month = dayjs().format(MONTH_FORMAT);
    this.user_id = user_id;
    this.building_id = building_id;

    await this.loadData(this.user_id, this.building_id, this.target_month);
    (this.$refs['TeacherPaymentDialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['TeacherPaymentDialog'] as CommonDialog).hide();
  }
}
